import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';


import Message from './Message';

var Messages = createReactClass({

    propTypes: {
        messages: pt.object.isRequired,
        type: pt.string
    },

    getInitialState: function () {
        return {
            filter: 'unread'
        };
    },

    toggleFilter: function (filter) {
        this.setState({
            filter: filter
        });
    },

    getReadCount: function () {
        var count = 0;
        Object.keys(this.props.messages).map(function (id) {
            if (this.props.messages[id].meta.read) count += 1;
        }, this);
        return count;
    },

    render: function () {
        var messages = [];

        Object.keys(this.props.messages).map(function (id, index) {
            var message = this.props.messages[id];
            var list = false;
            if (this.state.filter == 'all') list = true;
            if (this.state.filter == 'read' && message.meta.read) list = true;
            if (this.state.filter == 'unread' && !message.meta.read) list = true;
            if (list) {
                messages.push(<Message
                    key={'msg-' + this.props.type + '-' + message.msgID}
                    handleMarkAction={this.props.handleMarkAction}
                    message={message}
                    type={this.props.type}
                />);
            }
        }, this);

        if (!messages.length) {
            messages = (
                <div style={{color: '#494949', fontStyle: 'italic'}}>
                    <h4 className="text-center">No Messages here &hellip;</h4>
                </div>
            );
        }

        var readCount = this.getReadCount(),
            unreadCount = Object.keys(this.props.messages).length - readCount;

        return (
            <div className="messages info">

                <div className="btn-group" role="group" aria-label="message-listing-filter">
                    <button type="button" className={'btn btn-' + (this.state.filter == 'all' ? 'primary' : 'default')} onClick={this.toggleFilter.bind(null, 'all')}>All</button>
                    <button type="button" className={'btn btn-' + (this.state.filter == 'read' ? 'primary' : 'default')} onClick={this.toggleFilter.bind(null, 'read')}>Read <code style={{marginLeft: '.3em'}}>{readCount}</code></button>
                    <button type="button" className={'btn btn-' + (this.state.filter == 'unread' ? 'primary' : 'default')} onClick={this.toggleFilter.bind(null, 'unread')}>Unread <code style={{marginLeft: '.3em'}}>{unreadCount}</code></button>
                </div>

                <hr/>

                {messages}
            </div>
        );
    }
});
export default Messages
